import { environment } from 'src/environments/environment';

/**
 * Indica se a empresa (providerId) deve ter a previsao de atendimento oculta
 * no Express. Configuracao por ambiente em `environment.hidePrevisionProviderIds`.
 *
 * Lista vazia (padrao) = nenhuma empresa oculta, ou seja, comportamento anterior
 * preservado para todos os providers.
 */
export function isPrevisionHiddenForProvider(providerId: number): boolean {
  const hiddenProviders = environment.hidePrevisionProviderIds;

  if (!hiddenProviders || providerId === null || providerId === undefined) {
    return false;
  }

  return hiddenProviders.includes(providerId);
}
